import { ArrowRight } from "lucide-react"

export default function CTA() {
  return (
    <section className="relative overflow-hidden bg-slate-50 dark:bg-slate-800 pt-20 pb-24">
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute -top-24 -left-20 h-72 w-72 rounded-full bg-cyan-200/30 blur-3xl dark:bg-cyan-400/20"></div>
        <div className="absolute -bottom-24 -right-16 h-80 w-80 rounded-full bg-blue-200/30 blur-3xl dark:bg-blue-400/20"></div>
      </div>

      <div className="relative max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="rounded-3xl border border-slate-200/80 bg-white/90 dark:bg-slate-900/80 dark:border-slate-600 shadow-xl px-6 sm:px-10 lg:px-14 py-12 sm:py-14 text-center backdrop-blur-sm">
          <div className="space-y-8">
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 dark:text-white">Ready to transform your business finances?</h2>
            <p className="text-lg sm:text-xl text-slate-600 dark:text-slate-300 max-w-3xl mx-auto">
              Join thousands of businesses already using Accurix to streamline their accounting. Start your free trial
              today with zero setup friction.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button className="bg-blue-600 text-white px-8 py-4 rounded-xl hover:bg-blue-700 transition-colors flex items-center justify-center group shadow-sm">
                Start Free Trial
                <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
              </button>
              <button className="border-2 border-slate-300 text-slate-800 dark:border-slate-600 dark:text-slate-200 px-8 py-4 rounded-xl hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors">
                Schedule Demo
              </button>
            </div>

            <div className="flex flex-wrap items-center justify-center gap-3 sm:gap-6 text-slate-600 dark:text-slate-300 text-sm">
              <div className="flex items-center">
                <span className="text-emerald-500 mr-2">✓</span>
                14-day free trial
              </div>
              <div className="flex items-center">
                <span className="text-emerald-500 mr-2">✓</span>
                Setup in minutes
              </div>
              <div className="flex items-center">
                <span className="text-emerald-500 mr-2">✓</span>
                Cancel anytime
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
